import React from "react";
import MarketingArt from "../MarketingArt.jsx";

// Benefit card: same pattern as FeatureCard — the thumbnail replaces the icon
// tile rather than sitting beside it, and `icon` remains the fallback for any
// card whose image is missing or 404s.
const BenefitCard = ({ icon: Icon, image, title, description }) => {
  const iconTile = (
    <div className="w-full h-full rounded-[11px] bg-[color-mix(in_srgb,var(--land-primary)_10%,transparent)] text-[var(--land-primary)] grid place-items-center">
      <Icon size={18} />
    </div>
  );

  return (
    <div className="card-pop h-full flex gap-3.5 items-start bg-[var(--land-panel)] border border-[var(--land-line)] rounded-[16px] p-5">
      <div className="w-[56px] h-[56px] flex-none rounded-[11px] overflow-hidden border border-[var(--land-line)] bg-[var(--land-panel-2)]">
        {image ? (
          <MarketingArt src={image} className="w-full h-full object-cover block" fallback={iconTile} />
        ) : (
          iconTile
        )}
      </div>

      <div>
        <b className="font-disp font-bold text-[16px] tracking-[-.01em] text-[var(--land-ink)]">{title}</b>
        <p className="text-[var(--land-muted)] text-[15px] mt-1.5 leading-[1.62]">{description}</p>
      </div>
    </div>
  );
};

export default BenefitCard;
